import React from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const PlaidTestInfo: React.FC = () => {
  const testCredentials = [
    {
      institution: "First Platypus Bank",
      username: "user_good",
      password: "pass_good",
      description: "Good user with multiple accounts",
    },
    {
      institution: "First Gingham Credit Union",
      username: "user_good",
      password: "pass_good",
      description: "Credit union with checking and savings",
    },
    {
      institution: "Tattersall Federal Credit Union",
      username: "user_good",
      password: "pass_good",
      description: "Federal credit union",
    },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        <AlertTitle>Plaid Sandbox Test Credentials</AlertTitle>
        Use these test credentials when linking accounts in Plaid's sandbox
        environment:
      </Alert>

      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Institution</strong>
              </TableCell>
              <TableCell>
                <strong>Username</strong>
              </TableCell>
              <TableCell>
                <strong>Password</strong>
              </TableCell>
              <TableCell>
                <strong>Description</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {testCredentials.map((cred, index) => (
              <TableRow key={index}>
                <TableCell>{cred.institution}</TableCell>
                <TableCell>
                  <code>{cred.username}</code>
                </TableCell>
                <TableCell>
                  <code>{cred.password}</code>
                </TableCell>
                <TableCell>{cred.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Alert severity="warning">
        <AlertTitle>Important Notes</AlertTitle>
        <Typography variant="body2" component="div">
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li>
              This is a <strong>sandbox environment</strong> - no real bank data
              is accessed
            </li>
            <li>Do NOT enter real banking credentials</li>
            <li>
              For phone verification, use test number: <code>415-555-0123</code>
            </li>
            <li>
              When prompted for verification code, enter: <code>123456</code>
            </li>
            <li>
              If phone verification fails, try to skip it or select a different
              institution
            </li>
          </ul>
        </Typography>
      </Alert>
    </Box>
  );
};

export default PlaidTestInfo;
